import { Component, OnInit } from '@angular/core';
import { Fase } from '../../../models/fase';
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { FaseService } from '../fase.service';
import { AuthService } from '../../admin/auth.service';

@Component({
  templateUrl: './gerenciar-fase.component.html',
})
export class GerenciarFaseComponent extends WebPage implements OnInit {

  fases: Fase[];
  usuario:any;

  constructor(
    private confirmationService: ConfirmationService, messageService: MessageService,
    private faseService: FaseService, private authService: AuthService
  ) {
    super(messageService);
  }

  ngOnInit() {
    const mensagem = localStorage.getItem('mensagem');
    if (mensagem != null && mensagem !== '') {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: mensagem });
      localStorage.removeItem('mensagem');
    }

    this.usuario = this.authService.informacoesUsuario();

    this.getAllFases();
  }

  getAllFases(){
    this.isLoading = true;
    this.faseService.getAllFull()
      .finally(() => this.isLoading = false)
      .subscribe(
        fases => this.fases = fases,
        error => this.gerenciaErro(error)
      );
  }

  alterarConvocacao(fase: Fase){
    const acao = fase.convocacao ? "desabilitar" : "habilitar";

    this.confirmationService.confirm({
      message: 'Você deseja ' + acao +' a convocação nesta fase?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        fase.convocacao = !fase.convocacao
        this.faseService.editarConvocacaoFase(fase)
        .finally(() => this.isLoading = false)
        .subscribe (() => this.getAllFases())
      }
    });
  }

  excluiFase(fase) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.faseService.excluiFase(fase.idFase)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              const index = this.fases.indexOf(fase);
              this.fases.splice(index, 1);
            },
            error => this.gerenciaErro(error)
          );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/fase/gerenciar/gerenciar-fase.component.ts